export default {
  tabs: {
    access: 'Käyttöoikeus',
    notification_preferences: 'Ilmoitusasetukset',
  },
  sections: {
    notification_preferences: {
      title: 'Ilmoitusasetukset',
      form: {
        has_voice_call_reminders: {
          label: 'Vastaanota automaattisia puheluita odottavista tilauksista',
        },
        voice_reminders_phone_number: {
          label: 'Puhelinnumero puheluiden vastaanottamiseen',
        },
        has_whatsapp_notifications: {
          label: 'Lähetä ilmoituksia (esim. tilaukset keskeytetty) WhatsAppin kautta',
        },
        whatsapp_phone_number: {
          label: 'WhatsApp-puhelinnumero',
        },
        has_order_email_notifications: {
          label: 'Lähetä tilausilmoitukset sähköpostitse',
        },
        order_notifications_email: {
          label: 'Sähköpostiosoite tilausilmoitusten välittämiseen',
        },
      },
    },
    voice_calls: {
      title: 'Puhelut',
    },
    whats_app_notifications: {
      title: 'WhatsApp-ilmoitukset',
    },
    order_email_notifications: {
      title: 'Tilausten sähköposti-ilmoitukset',
    },
    access_control: {
      title: 'Käyttöoikeuksien hallinta',
      form: {
        company_ids: {
          label: 'Pääsy ravintoloihin',
          tooltip: 'Antaa pääsyn seuraaviin ravintoloihin (lisäksi saman brändin ravintoloihin)',
        },
      },
    },
  },
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    failed_to_save_changes: 'Muutosten tallentaminen epäonnistui',
    changes_got_saved: 'Muutokset tallennettiin',
  },
};
